import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseSubResource, dataToken } from '../../../core/abstractions/base.sub-resource';
import { ApiResponseModel } from '../../../models/core/api-response.model';
import { PaymentAccountModel } from '../../../models/payment-account.model';

@Component({
    selector: 'sl-payment-accounts',
    templateUrl: './payment-accounts.component.html',
    styleUrls: ['./payment-accounts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentAccountsComponent extends BaseSubResource {
    readonly accounts: PaymentAccountModel[] = [];

    private readonly componentData = inject<ApiResponseModel<PaymentAccountModel[]>>(dataToken);

    constructor() {
        super();
        this.accounts = this.componentData.value;
    }
}
